import React, { FunctionComponent, ReactNode } from 'react';
import Header from 'app/components/header/Header';
import Page from 'app/components/layout/Page';
import PublishedLessonNavigation from 'app/components/publishedLesson/PublishedLessonNavigation';
import { useSetHttpStatus } from 'app/utils/HttpStatusState';

interface IProps {
  status: number;
  title?: string;
  children: ReactNode;
}

const ErrorPage: FunctionComponent<IProps> = ({ status, title, children }) => {
  useSetHttpStatus(status);
  return (
    <Page
      title={title}
      header={
        <Header stickies={<PublishedLessonNavigation />} />
      }
    >
      {children}
    </Page>
  );
};

export default ErrorPage;
